export class DropboxProcessAuthorizationCodeRequest{
    public code!:string;
    public state!:string;
    public nonce?:string;
}